
import { Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"

export default {
  components: {
    [Drawer.name]: Drawer,
    drawerHeader
  },
  props: {
    paymentMethod: {
      type: Object,
      default: () => {}
    },
    promotionEnjoy: {
      type: Object,
      default: () => {}
    },
    payMethodsPromo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      visible: false
    }
  },
  computed: {
    paymentMethodId() {
      return this.paymentMethod?.paymentMethodId || ""
    },
    promoText() {
      const key = this.paymentMethod
        ? `${this.paymentMethod.paymentMethodId}_${this.paymentMethod.signNum || "null"}`
        : ""
      const promoList = this.payMethodsPromo && key ? this.payMethodsPromo[key]?.promoDiscountResponseList : null
      return promoList && promoList.length ? promoList[0]?.discountText : ""
    }
  },
  mounted() {},
  methods: {
    handleOpened() {
      this.$sdk.showPaymentMethods({
        container: "#payment-container",
        payMethodsPromo: this.payMethodsPromo,
        selectMethod: this.paymentMethod,
        onSelect: result => {
          this.$emit("changed", result)
          this.visible = false
        },
        onError: function (error) {
          this.$message.error(error)
        }
      })
    }
  }
}
